import { bn, bnFrom, divideBignumbers, humanizeBn, multiplyBignumbers } from 'tools';
import { convertBnToDecimals } from 'tools';
import { ICexPair, IDexPair } from 'types/pairs';

export const convertTokenDEX = ({
  from,
  to,
  pair,
  amount,
  decimals,
}: {
  from: string;
  to: string;
  pair: IDexPair;
  amount: string;
  decimals: number;
}) => {
  if (isNaN(Number(amount))) return bn(0);

  const pricesUSD = {
    [pair.token_quote.symbol]: bnFrom(pair.token_quote.price_usd),
    [pair.token_base.symbol]: bnFrom(pair.token_base.price_usd),
    [pair.token_fee.symbol]: bnFrom(pair.token_fee.price_usd),
    USD: bn('1', 6),
  };

  if (from === to) return convertBnToDecimals(bn(amount, 18), 18, decimals);

  if (!pricesUSD[from] || !pricesUSD[to] || pricesUSD[to].eq(0)) return bn(0);

  const convertPrice = divideBignumbers([pricesUSD[from], 6], [pricesUSD[to], 6]);

  const result = convertBnToDecimals(
    multiplyBignumbers([bn(amount, 18), 18], [convertPrice, 18]),
    18,
    decimals,
  );

  return result;
};

export const convertTokenCEX = ({
  from,
  to,
  pair,
  amount,
}: {
  from: string;
  to: string;
  pair: ICexPair;
  amount: string;
}) => {
  if (isNaN(Number(amount))) return bn(0);

  const pricesUSD = {
    [pair.token_quote.symbol]: bnFrom(pair.token_quote.price_usd),
    [pair.token_base.symbol]: bnFrom(pair.token_base.price_usd),
    USD: bn('1', 6),
  };

  if (from === to) return bn(amount, 18);

  if (!pricesUSD[from] || !pricesUSD[to] || pricesUSD[to].eq(0)) return bn(0);

  const convertPrice = divideBignumbers([pricesUSD[from], 6], [pricesUSD[to], 6]);

  const result = multiplyBignumbers([bn(amount, 18), 18], [convertPrice, 18]);

  return result;
};

export const humanizeDexToken = ({
  amount,
  token,
  dexPair,
}: {
  amount: string;
  token: string;
  dexPair: IDexPair;
}) => {
  switch (token.toLowerCase()) {
    case dexPair.token_base.address.toLowerCase(): {
      return humanizeBn(bnFrom(amount), dexPair.token_base.decimals);
    }
    case dexPair.token_fee.address.toLowerCase(): {
      return humanizeBn(bnFrom(amount), dexPair.token_fee.decimals);
    }
    default: {
      return humanizeBn(bnFrom(amount), 6);
    }
  }
};

export const dexTokenToBN = ({
  amount,
  token,
  dexPair,
}: {
  amount: string;
  token: string;
  dexPair: IDexPair;
}) => {
  switch (token.toUpperCase()) {
    case dexPair.token_base.symbol.toUpperCase(): {
      return bn(amount, dexPair.token_base.decimals);
    }
    case dexPair.token_fee.symbol.toUpperCase(): {
      return bn(amount, dexPair.token_fee.decimals);
    }
    default: {
      return bn(amount, 6);
    }
  }
};
